export default {"src":"/_next/static/image/assets/Illustrations/stack empty state.e72594f4df44e20e5f0ad26f5f9ed661.svg","height":160,"width":168};